import Common from "../modules/common";
import "selectric";

const templateToolbox = {
  filtered: false,

  init() {
    this.events();
    $(".filters__item").selectric({
      disableOnMobile: false,
      nativeOnMobile: false
    });
    this.stickyFilters();
  },

  events() {
    // $(".load-more").on("click", () => {
    //   templateToolbox.loadMore();
    // });

    $(document).on('keyup mouseup', ".load-more", function (e) {
      templateToolbox.loadMore(e.currentTarget);
    });

    /**
     * Toolbox filters event handler
    */
    let throttle = null;
    $('select').on('selectric-change', function () {
      const filters = document.querySelector('.filters');
      clearTimeout(throttle);
      throttle = setTimeout(function () {
        templateToolbox.handleFilters();
        templateToolbox.filtered = true;
        templateToolbox.resetBtnMobile(templateToolbox.filtered);
        templateToolbox.filtersIndicator(templateToolbox.filtered);
        templateToolbox.resetBtn(templateToolbox.filtered);

        const selects = document.querySelectorAll('.filters__item');
        let count = 0;

        selects.forEach(select => {
          if (select.selectedIndex > 0) {
            count++;
          }
        });

        const counter = document.getElementById('filter-count');
        if (counter) {
          counter.textContent = count;
        }

      }, 500);
    });

    $('.filters__close-btn').on('click', (e) => {
      this.filtered = false;
      this.handleFilters(true);
      this.resetBtn(false);
      this.resetBtnMobile(false);
      this.filtersIndicator(false);
      const btnEl = $(e.currentTarget);
      // Resets selectric selections.
      $('.filters__item').prop('selectedIndex', 0).selectric('refresh');

      $('#filter-count').text('0');
    });

    $('.filters__close-btn-mobile').on('click', (e) => {
      this.filtered = false;
      this.handleFilters(true);
      this.resetBtnMobile(false);
      this.resetBtn(false);
      this.filtersIndicator(false);
      const btnEl = $(e.currentTarget);
      // Resets selectric selections.
      $('.filters__item').prop('selectedIndex', 0).selectric('refresh');
      
      $('#filter-count').text('0');
    });

  },

  loadMore(btn) {
    btn = $(btn);

    if (btn.hasClass("loading-btn")) {
      return;
    }

    btn.addClass("loading-btn");

    let data = {
      action: "load_more_handler",
      taxonomy: btn.attr("data-type"),
      slug: btn.attr("data-slug"),
      page: btn.attr("data-page"),
    };

    $.ajax({
      url: Sage.ajaxurl,
      type: "POST",
      data: data,
    })
      .done((response) => {
        btn.removeClass("loading-btn");
        $(
          ".toolbox-category__items[data-slug=" + btn.attr("data-slug") + "]"
        ).append(response.data.html);
        Common.lazyLoadInstance.update();

        btn.attr("data-page", response.data.page);

        if (!response.data.btn) {
          btn.css({ display: "none" });
        }
      })
      .always(() => {
        btn.removeClass("loading-btn");
      });
  },

  /**
   * Create url with filters
   */
  handleFilters(clear = false) {
    $('.loader').addClass('loading');

    let filters = {};

    $('.filters select').each(function () {
      const select = $(this);
      const name = select.data('cat');
      const slug = $(this).find(':selected').data('slug');


      if (slug !== undefined) {
        filters[name] = slug;
      }

    });

    if (clear == true) {
      filters = {};
      templateToolbox.filtered = false;
      $('.filtered__close-btn').addClass('hidden');
    };

    const searchParams = new URLSearchParams(filters);
    const url = window.location.pathname + '?' + searchParams.toString();

    history.pushState(filters, '', url);
    templateToolbox.loadToolboxes(filters);
  },

  /**
   * Get items from backend
   */
  loadToolboxes(filters) {
    // Ajax
    $.ajax({
      url: Sage.ajaxurl,
      type: 'POST',
      data: {
        action: 'filtered_toolbox',
        format: filters.format,
        category: filters.category,
        tag: filters.tag,
        lang: filters.lang,
      },
    }).done(function (response) {
      templateToolbox.trashNoResults();
      $('.toolbox-category-wrap').remove();
      $('.main #tbFilters').after(response.html);
      Common.lazyLoadInstance.update();


    }).always(function () {
      $('.loader').removeClass('loading');
    });
  },

  resetBtn(state) {
    let btnEl = $('.filters__close-btn');

    if (state) {
      btnEl.removeClass('hidden');
    } else {
      btnEl.addClass('hidden');
    }
  },

  resetBtnMobile(state) {
    let btnEl = $('.filters__close-btn-mobile');

    if (state) {
      btnEl.removeClass('hidden');
    } else {
      btnEl.addClass('hidden');
    }
  },

  filtersIndicator(state) {
    let btnEl = $('.filters__indicator');

    if (state) {
      btnEl.removeClass('hidden');
    } else {
      btnEl.addClass('hidden');
    }
  },

  trashNoResults() {
    $('.no-results').remove();
  },

  stickyFilters() {
    document.addEventListener("scroll", () => {
      const filtersBase = document.getElementById("tbFilters");
      const filters = document.querySelector(".filters");

      if (!filtersBase || !filters) return;

      const rect = filtersBase.getBoundingClientRect();

      if (rect.top < 10) {
        filters.classList.add("sticky");
      } else {
        filters.classList.remove("sticky");
      }

    });

    const toggleMobFilters = document.querySelector(".filters__title-wrapper > svg");
    const mobFilters = document.querySelector('.filters');

    if (!toggleMobFilters || !mobFilters) return;

    const mediaQuery = window.matchMedia("(max-width: 900px)");

    function handleViewportChange(event) {
      if (event.matches) {

        toggleMobFilters.addEventListener("click", () => {
          if (!mobFilters.classList.contains("sticky")) return;

          if (mobFilters.classList.contains("open")) {
            mobFilters.classList.remove("open");
          } else {
            mobFilters.classList.add("open");
          }
        })
      }
    }

    handleViewportChange(mediaQuery);

    mediaQuery.addEventListener('change', handleViewportChange);

  }
};

export default templateToolbox;
